export enum NotificationType {
  ADDEMPLOYEE = 'AddEmployee',
  ALIVESHAREDCOACH = 'ALIVESharedCoach',
  ALIVESHAREDMANAGER = 'ALIVESharedManager',
  ALIVESHAREDNOCOACH = 'ALIVESharedNoCoach',
  ASSESSMENTAVAILABLEEMPLOYEE = 'AssessmentAvailableEmployee',
  COMPLETEDASSESSMENT = 'CompletedAssessment',
  CREATEPMMANAGER = 'CreatePmManager',
  PMREADYFORAPPROVAL = 'PmReadyForApproval',
  PMSETTOACTIVE = 'PmSetToActive',
  CREATEPOPMANAGER = 'CreatePopManager',
  POPREADYFORAPPROVAL = 'PopReadyForApproval',
  POPSETTOACTIVE = 'PopSetToActive',
  ONBOARDING = 'ONBOARDING',
  MEETINGREADYFORAPPROVAL = 'MeetingReadyForApproval',
  POPFEEDBACKREQUEST = 'PopFeedbackRequest',
  PMFEEDBACKREQUEST = 'PmFeedbackRequest',
  POPFEEDBACKCOMPLETED = 'PopFeedbackCompleted',
  PMFEEDBACKCOMPLETED = 'PmFeedbackCompleted',
  POPSELFREFLECTIONREQUEST = 'PopSelfReflectionRequest',
  PMSELFREFLECTIONREQUEST = 'PmSelfReflectionRequest',
  POPSELFREFLECTIONCOMPLETED = 'PopSelfReflectionCompleted',
  PMSELFREFLECTIONCOMPLETED = 'PmSelfReflectionCompleted',
}

export const notificationButtonLabel: Record<NotificationType, string> = {
  [NotificationType.ADDEMPLOYEE]: 'Medewerker bekijken',
  [NotificationType.ALIVESHAREDCOACH]: 'Resultaten bekijken',
  [NotificationType.ALIVESHAREDMANAGER]: 'Resultaten bekijken',
  [NotificationType.COMPLETEDASSESSMENT]: 'Resultaten bekijken',
  [NotificationType.ALIVESHAREDNOCOACH]: 'Assessment bekijken',
  [NotificationType.ASSESSMENTAVAILABLEEMPLOYEE]: 'Assessment bekijken',
  [NotificationType.CREATEPMMANAGER]: 'PM bekijken',
  [NotificationType.PMREADYFORAPPROVAL]: 'PM bekijken',
  [NotificationType.PMSETTOACTIVE]: 'PM bekijken',
  [NotificationType.CREATEPOPMANAGER]: 'POP bekijken',
  [NotificationType.POPREADYFORAPPROVAL]: 'POP bekijken',
  [NotificationType.POPSETTOACTIVE]: 'POP bekijken',
  [NotificationType.ONBOARDING]: 'POP bekijken',
  [NotificationType.MEETINGREADYFORAPPROVAL]: 'Afspraak bekijken',
  [NotificationType.POPFEEDBACKREQUEST]: 'Feedback invullen',
  [NotificationType.PMFEEDBACKREQUEST]: 'Feedback invullen',
  [NotificationType.POPFEEDBACKCOMPLETED]: 'POP bekijken',
  [NotificationType.PMFEEDBACKCOMPLETED]: 'PM bekijken',
  [NotificationType.POPSELFREFLECTIONREQUEST]: 'Reflectie invullen',
  [NotificationType.PMSELFREFLECTIONREQUEST]: 'Reflectie invullen',
  [NotificationType.POPSELFREFLECTIONCOMPLETED]: 'POP bekijken',
  [NotificationType.PMSELFREFLECTIONCOMPLETED]: 'PM bekijken',
};
